/**
 * 検索ボタン付きの入力欄
 */

import CloseIcon from '@assets/images/common/icon/close.svg';
import SearchIcon from '@assets/images/common/icon/search/search.svg';
import { ChangeEvent, FocusEvent, KeyboardEvent } from 'react';

type Props = {
  value?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  onClear?: () => void;
  placeholder?: string;
  defaultValue?: string;
};

const InputSearch = ({
  value,
  defaultValue,
  onChange,
  onKeyDown,
  onFocus,
  onBlur,
  onSubmit,
  onClear,
  placeholder = 'キーワード検索',
}: Props) => {
  const currentValue = value ?? defaultValue ?? '';
  const showClearButton = currentValue.length > 0;

  return (
    <div className='flex rounded-[2px] border border-solid border-gray-400'>
      <input
        className='w-full flex-1 px-[16px] py-[10px] text-sm outline-none placeholder:text-gray-400 lg:text-base'
        type='text'
        placeholder={placeholder}
        value={currentValue}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        data-testid='input-search'
      />
      {showClearButton && (
        <button
          className='grid w-[36px] place-items-center transition-colors hover:bg-gray-100'
          type='button'
          onClick={onClear}
          aria-label='クリア'
        >
          <img
            className='size-[16px]'
            src={CloseIcon}
            alt='クリア'
            width='16'
            height='16'
          />
        </button>
      )}
      <button
        className='grid w-[36px] place-items-center transition-colors hover:bg-gray-100'
        type='button'
        onClick={onSubmit}
        aria-label='検索'
      >
        <img
          className='size-[20px]'
          src={SearchIcon}
          alt=''
          width='20'
          height='20'
        />
      </button>
    </div>
  );
};

export default InputSearch;
